import flarebase from 'flarebase'

class StoreManager extends flarebase.store.StoreManager {
  constructor() {
    super();
  }
  watch() {
    if (this._watchPromise) return this._watchPromise;

    this._watchPromise = new Promise(async (resolve) => {
      this.currentUser = this.collection('users').doc(app.auth.currentUser.uid);
      await this.currentUser.watch();

      // 全てに反映
      riot.update();

      resolve();
    });

    return this._watchPromise;
  }

  async unwatch() {
    if (!this._watchPromise) return ;

    this.currentUser.unwatch();
    this.currentUser = null;

    this._watchPromise = null;    
  }
}

var store = new StoreManager();

/*
 * record class
 */
store.registerDocumentStoreClass('records', class extends flarebase.store.DocumentStore {
  constructor(item) {
    super(item);
  }

  // 自分のレコードかを判定
  isMine() {
    let uid = app.auth.currentUser.uid;
    return uid === this.data.created_user_ref.id;
  }

  getDuration() {
    return this.data.end_at - this.data.start_at;
  }

  getColor() {
    return this.relation.project && this.relation.project.doc.exists ? this.relation.project.getColor() : app.utils.defaultColor;
  }

  getTooltipContent() {
    var content = '';
    
    content += this.relation.project && this.relation.project.doc.exists ? `${this.relation.project.data.name}\n` : '';
    content += this.data.title ? `${this.data.title}\n` : '';
    content += `${dayjs(this.data.start_at).format('HH:mm')} - ${dayjs(this.data.end_at).format('HH:mm')}`;

    return content;
  }
});


/*
 * project class
 */
store.registerDocumentStoreClass('projects', class extends flarebase.store.DocumentStore {
  constructor(item) {
    super(item);
  }

  // 自分の色を取得
  getColor() {
    return this.data.color || app.utils.defaultColor;
  }
});

/*
 * templates class
 */
store.registerDocumentStoreClass('templates', class extends flarebase.store.DocumentStore {
  constructor(item) {
    super(item);
  }

  getColor() {
    // 背景色を設定
    return this.relation.project && this.relation.project.doc.exists ? this.relation.project.getColor() : app.utils.defaultColor;
  }
});




export default store;